import gql from 'graphql-tag';

export const transmitOrderMutation = gql`
  mutation transmitOrder($input: EditOrderInput!) {
    transmitOrder(input: $input) {
      Status
    }
  }
`;
